import { render, staticRenderFns } from "./FederationControl.vue?vue&type=template&id=1a490002&scoped=true&"
import script from "./FederationControl.vue?vue&type=script&lang=js&"
export * from "./FederationControl.vue?vue&type=script&lang=js&"
import style0 from "./FederationControl.vue?vue&type=style&index=0&id=1a490002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a490002",
  null
  
)

export default component.exports